import { render, staticRenderFns } from "./SSDashboardChart.vue?vue&type=template&id=5b042f5f&"
import script from "./SSDashboardChart.vue?vue&type=script&lang=js&"
export * from "./SSDashboardChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports